/**
 * Soft scroll reveals for a quieter luxury storefront.
 */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  const targets = document.querySelectorAll(
    '.shopify-section:not(:has(.hero)) .section, .shopify-section:not(:has(.hero)) .product-grid, .product-card, .collection-card'
  );

  targets.forEach((el) => {
    if (el.closest('header-component') || el.closest('footer')) return;
    el.classList.add('luxury-reveal');
  });

  const reveals = document.querySelectorAll('.luxury-reveal');
  if (!reveals.length || !('IntersectionObserver' in window)) {
    reveals.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  reveals.forEach((el) => observer.observe(el));
})();
